import { render, staticRenderFns } from "./TileNavigationButton.vue?vue&type=template&id=d2a1df22&scoped=true"
import script from "./TileNavigationButton.vue?vue&type=script&lang=js"
export * from "./TileNavigationButton.vue?vue&type=script&lang=js"
import style0 from "./TileNavigationButton.vue?vue&type=style&index=0&id=d2a1df22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a1df22",
  null
  
)

export default component.exports